<template>
    <svg width="100" height="100" viewBox="0 -6 65 64" xmlns="http://www.w3.org/2000/svg" style="background: white;">
        <defs>
            <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stop-color="#F2153E" />
                <stop offset="100%" stop-color="#FD7E14" />
            </linearGradient>
        </defs>

        <!-- Cabeza centrada -->
        <circle cx="32" cy="16" r="8" fill="url(#grad)" />

        <!-- Cuerpo centrado debajo de la cabeza -->
        <path d="M18,41 a14,14 0 0,1 29,0 z" fill="url(#grad)" />

        <!-- Recorte simulado del cuerpo (más alto: altura = 12 en lugar de 10) -->
        <g transform="rotate(135 47 40)">
            <path d="M43,43 h12 l4,4 -4,3 h-13 a1,1 0 0 1 -1,-1 v-4 a1,1 0 0 1 1,-1 z" fill="white" />
        </g>

        <!-- Lápiz como un solo objeto -->
        <g transform="rotate(135 47 40)">
            <path d="M42,42 h12 l4,3 -4,3 h-12 a1,1 0 0 1 -1,-1 v-4 a1,1 0 0 1 1,-1 z" fill="url(#grad)" />
        </g>
    </svg>

</template>

<script>
export default {
    name: 'ProfileAvatar'
}
</script>
